import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

var _4aa1634e = function _4aa1634e() {
	return import('../pages/index.vue' /* webpackChunkName: "pages/index" */).then(function (m) {
		return m.default || m;
	});
};
var _540aa2bc = function _540aa2bc() {
	return import('../pages/read/index.vue' /* webpackChunkName: "pages/read/index" */).then(function (m) {
		return m.default || m;
	});
};
var _e28d925c = function _e28d925c() {
	return import('../pages/partner/index.vue' /* webpackChunkName: "pages/partner/index" */).then(function (m) {
		return m.default || m;
	});
};
var _745e37bb = function _745e37bb() {
	return import('../pages/engineer/index.vue' /* webpackChunkName: "pages/engineer/index" */).then(function (m) {
		return m.default || m;
	});
};
var _3e0116af = function _3e0116af() {
	return import('../pages/demo/index.vue' /* webpackChunkName: "pages/demo/index" */).then(function (m) {
		return m.default || m;
	});
};
var _60f7b3e3 = function _60f7b3e3() {
	return import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */).then(function (m) {
		return m.default || m;
	});
};
var _e6a820de = function _e6a820de() {
	return import('../pages/partner/tasks/index.vue' /* webpackChunkName: "pages/partner/tasks/index" */).then(function (m) {
		return m.default || m;
	});
};
var _61f1b931 = function _61f1b931() {
	return import('../pages/account/requestation.vue' /* webpackChunkName: "pages/account/requestation" */).then(function (m) {
		return m.default || m;
	});
};
var _12939006 = function _12939006() {
	return import('../pages/engineer/dashboard.vue' /* webpackChunkName: "pages/engineer/dashboard" */).then(function (m) {
		return m.default || m;
	});
};
var _799698bc = function _799698bc() {
	return import('../pages/customer/edit.vue' /* webpackChunkName: "pages/customer/edit" */).then(function (m) {
		return m.default || m;
	});
};
var _03c6d07e = function _03c6d07e() {
	return import('../pages/customer/profile.vue' /* webpackChunkName: "pages/customer/profile" */).then(function (m) {
		return m.default || m;
	});
};
var _1030ec05 = function _1030ec05() {
	return import('../pages/admin/select-cutomer.vue' /* webpackChunkName: "pages/admin/select-cutomer" */).then(function (m) {
		return m.default || m;
	});
};
var _7f05dd11 = function _7f05dd11() {
	return import('../pages/admin/remind/index.vue' /* webpackChunkName: "pages/admin/remind/index" */).then(function (m) {
		return m.default || m;
	});
};
var _4b93948a = function _4b93948a() {
	return import('../pages/admin/engineer/index.vue' /* webpackChunkName: "pages/admin/engineer/index" */).then(function (m) {
		return m.default || m;
	});
};
var _34fa7760 = function _34fa7760() {
	return import('../pages/admin/project.vue' /* webpackChunkName: "pages/admin/project" */).then(function (m) {
		return m.default || m;
	});
};
var _3499d98a = function _3499d98a() {
	return import('../pages/project/create.vue' /* webpackChunkName: "pages/project/create" */).then(function (m) {
		return m.default || m;
	});
};
var _6ee0f1fd = function _6ee0f1fd() {
	return import('../pages/account/change-password.vue' /* webpackChunkName: "pages/account/change-password" */).then(function (m) {
		return m.default || m;
	});
};
var _1c106b8c = function _1c106b8c() {
	return import('../pages/partner/edit.vue' /* webpackChunkName: "pages/partner/edit" */).then(function (m) {
		return m.default || m;
	});
};
var _792c66a4 = function _792c66a4() {
	return import('../pages/account/registration.vue' /* webpackChunkName: "pages/account/registration" */).then(function (m) {
		return m.default || m;
	});
};
var _ca499464 = function _ca499464() {
	return import('../pages/admin/task.vue' /* webpackChunkName: "pages/admin/task" */).then(function (m) {
		return m.default || m;
	});
};
var _41e0119b = function _41e0119b() {
	return import('../pages/admin/dashboard.vue' /* webpackChunkName: "pages/admin/dashboard" */).then(function (m) {
		return m.default || m;
	});
};
var _e6ea637c = function _e6ea637c() {
	return import('../pages/engineer/project.vue' /* webpackChunkName: "pages/engineer/project" */).then(function (m) {
		return m.default || m;
	});
};
var _59414428 = function _59414428() {
	return import('../pages/partner/profile/index.vue' /* webpackChunkName: "pages/partner/profile/index" */).then(function (m) {
		return m.default || m;
	});
};
var _13e20dc7 = function _13e20dc7() {
	return import('../pages/account/redirect.vue' /* webpackChunkName: "pages/account/redirect" */).then(function (m) {
		return m.default || m;
	});
};
var _65b6c717 = function _65b6c717() {
	return import('../pages/admin/setting.vue' /* webpackChunkName: "pages/admin/setting" */).then(function (m) {
		return m.default || m;
	});
};
var _3da28b2c = function _3da28b2c() {
	return import('../pages/customer/dashboard.vue' /* webpackChunkName: "pages/customer/dashboard" */).then(function (m) {
		return m.default || m;
	});
};
var _5beb980e = function _5beb980e() {
	return import('../pages/account/profile.vue' /* webpackChunkName: "pages/account/profile" */).then(function (m) {
		return m.default || m;
	});
};
var _59ec7ba8 = function _59ec7ba8() {
	return import('../pages/account/upload.vue' /* webpackChunkName: "pages/account/upload" */).then(function (m) {
		return m.default || m;
	});
};
var _2ee978d2 = function _2ee978d2() {
	return import('../pages/admin/partner/index.vue' /* webpackChunkName: "pages/admin/partner/index" */).then(function (m) {
		return m.default || m;
	});
};
var _2b93f034 = function _2b93f034() {
	return import('../pages/admin/customer-list.vue' /* webpackChunkName: "pages/admin/customer-list" */).then(function (m) {
		return m.default || m;
	});
};
var _5ebdd394 = function _5ebdd394() {
	return import('../pages/partner/dashboard.vue' /* webpackChunkName: "pages/partner/dashboard" */).then(function (m) {
		return m.default || m;
	});
};
var _216f7b6c = function _216f7b6c() {
	return import('../pages/engineer/settings.vue' /* webpackChunkName: "pages/engineer/settings" */).then(function (m) {
		return m.default || m;
	});
};
var _678dc097 = function _678dc097() {
	return import('../pages/admin/user/index.vue' /* webpackChunkName: "pages/admin/user/index" */).then(function (m) {
		return m.default || m;
	});
};
var _664b1765 = function _664b1765() {
	return import('../pages/project/create-demo.vue' /* webpackChunkName: "pages/project/create-demo" */).then(function (m) {
		return m.default || m;
	});
};
var _22aa8831 = function _22aa8831() {
	return import('../pages/engineer/edit.vue' /* webpackChunkName: "pages/engineer/edit" */).then(function (m) {
		return m.default || m;
	});
};
var _7302156a = function _7302156a() {
	return import('../pages/account/forgot-password.vue' /* webpackChunkName: "pages/account/forgot-password" */).then(function (m) {
		return m.default || m;
	});
};
var _12caa3d3 = function _12caa3d3() {
	return import('../pages/admin/edit.vue' /* webpackChunkName: "pages/admin/edit" */).then(function (m) {
		return m.default || m;
	});
};
var _956592fc = function _956592fc() {
	return import('../pages/customer/list-project.vue' /* webpackChunkName: "pages/customer/list-project" */).then(function (m) {
		return m.default || m;
	});
};
var _27871e30 = function _27871e30() {
	return import('../pages/customer/setting.vue' /* webpackChunkName: "pages/customer/setting" */).then(function (m) {
		return m.default || m;
	});
};
var _4e332ef8 = function _4e332ef8() {
	return import('../pages/account/request-password.vue' /* webpackChunkName: "pages/account/request-password" */).then(function (m) {
		return m.default || m;
	});
};
var _4af1786a = function _4af1786a() {
	return import('../pages/admin/customer/index.vue' /* webpackChunkName: "pages/admin/customer/index" */).then(function (m) {
		return m.default || m;
	});
};
var _08704be0 = function _08704be0() {
	return import('../pages/admin/customer/create-project.vue' /* webpackChunkName: "pages/admin/customer/create-project" */).then(function (m) {
		return m.default || m;
	});
};
var _9c42c5f2 = function _9c42c5f2() {
	return import('../pages/admin/user/create.vue' /* webpackChunkName: "pages/admin/user/create" */).then(function (m) {
		return m.default || m;
	});
};
var _166c1feb = function _166c1feb() {
	return import('../pages/admin/partner/resend.vue' /* webpackChunkName: "pages/admin/partner/resend" */).then(function (m) {
		return m.default || m;
	});
};
var _7555d877 = function _7555d877() {
	return import('../pages/project/quotation/create-revise.vue' /* webpackChunkName: "pages/project/quotation/create-revise" */).then(function (m) {
		return m.default || m;
	});
};
var _6c15fade = function _6c15fade() {
	return import('../pages/project/quotation/create.vue' /* webpackChunkName: "pages/project/quotation/create" */).then(function (m) {
		return m.default || m;
	});
};
var _236045e4 = function _236045e4() {
	return import('../pages/admin/email/setting.vue' /* webpackChunkName: "pages/admin/email/setting" */).then(function (m) {
		return m.default || m;
	});
};
var _3af1df94 = function _3af1df94() {
	return import('../pages/admin/customer/create.vue' /* webpackChunkName: "pages/admin/customer/create" */).then(function (m) {
		return m.default || m;
	});
};
var _d776673a = function _d776673a() {
	return import('../pages/admin/engineer/create.vue' /* webpackChunkName: "pages/admin/engineer/create" */).then(function (m) {
		return m.default || m;
	});
};
var _5e75fbf8 = function _5e75fbf8() {
	return import('../pages/admin/user/role/index.vue' /* webpackChunkName: "pages/admin/user/role/index" */).then(function (m) {
		return m.default || m;
	});
};
var _540c27a8 = function _540c27a8() {
	return import('../pages/admin/partner/create.vue' /* webpackChunkName: "pages/admin/partner/create" */).then(function (m) {
		return m.default || m;
	});
};
var _490becd7 = function _490becd7() {
	return import('../pages/admin/email/resend.vue' /* webpackChunkName: "pages/admin/email/resend" */).then(function (m) {
		return m.default || m;
	});
};
var _1747a856 = function _1747a856() {
	return import('../pages/project/tasks/edit/_id.vue' /* webpackChunkName: "pages/project/tasks/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _298da24d = function _298da24d() {
	return import('../pages/admin/customer/edit/_id.vue' /* webpackChunkName: "pages/admin/customer/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _cf7e6200 = function _cf7e6200() {
	return import('../pages/admin/user/edit/_id.vue' /* webpackChunkName: "pages/admin/user/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _79d8975c = function _79d8975c() {
	return import('../pages/admin/engineer/edit/_id.vue' /* webpackChunkName: "pages/admin/engineer/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _22c4e8e5 = function _22c4e8e5() {
	return import('../pages/admin/partner/edit/_id.vue' /* webpackChunkName: "pages/admin/partner/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _4b472d70 = function _4b472d70() {
	return import('../pages/project/tasks/view/_id.vue' /* webpackChunkName: "pages/project/tasks/view/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _ea3abb8e = function _ea3abb8e() {
	return import('../pages/partner/tasks/_id.vue' /* webpackChunkName: "pages/partner/tasks/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _4312e55c = function _4312e55c() {
	return import('../pages/admin/customer/_id.vue' /* webpackChunkName: "pages/admin/customer/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _61fa6e5c = function _61fa6e5c() {
	return import('../pages/customer/project/_id.vue' /* webpackChunkName: "pages/customer/project/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _b0872a3a = function _b0872a3a() {
	return import('../pages/admin/engineer/_id.vue' /* webpackChunkName: "pages/admin/engineer/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _61c387ba = function _61c387ba() {
	return import('../pages/admin/partner/_id.vue' /* webpackChunkName: "pages/admin/partner/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _c9317370 = function _c9317370() {
	return import('../pages/project/quotation/_id.vue' /* webpackChunkName: "pages/project/quotation/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _28d08834 = function _28d08834() {
	return import('../pages/project/edit/_id.vue' /* webpackChunkName: "pages/project/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _6ff0fcbf = function _6ff0fcbf() {
	return import('../pages/admin/user/_id.vue' /* webpackChunkName: "pages/admin/user/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _1eeba26c = function _1eeba26c() {
	return import('../pages/project/tasks/_id.vue' /* webpackChunkName: "pages/project/tasks/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _1c3dc74c = function _1c3dc74c() {
	return import('../pages/partner/tasks/t_id_backup.vue' /* webpackChunkName: "pages/partner/tasks/t_id_backup" */).then(function (m) {
		return m.default || m;
	});
};
var _4ffcece3 = function _4ffcece3() {
	return import('../pages/engineer/_id.vue' /* webpackChunkName: "pages/engineer/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _ca2bf222 = function _ca2bf222() {
	return import('../pages/resend/_id.vue' /* webpackChunkName: "pages/resend/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _4e6ac5ba = function _4e6ac5ba() {
	return import('../pages/partner/_id.vue' /* webpackChunkName: "pages/partner/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _f291e15c = function _f291e15c() {
	return import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _224daa15 = function _224daa15() {
	return import('../pages/account/_login.vue' /* webpackChunkName: "pages/account/_login" */).then(function (m) {
		return m.default || m;
	});
};
var _3997530b = function _3997530b() {
	return import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _15b5463f = function _15b5463f() {
	return import('../pages/_shared/user.vue' /* webpackChunkName: "pages/_shared/user" */).then(function (m) {
		return m.default || m;
	});
};
var _8b964e3a = function _8b964e3a() {
	return import('../pages/_shared/engineer.vue' /* webpackChunkName: "pages/_shared/engineer" */).then(function (m) {
		return m.default || m;
	});
};
var _deb6c6ea = function _deb6c6ea() {
	return import('../pages/_shared/admin.vue' /* webpackChunkName: "pages/_shared/admin" */).then(function (m) {
		return m.default || m;
	});
};
var _c2f0ea5c = function _c2f0ea5c() {
	return import('../pages/_shared/customer.vue' /* webpackChunkName: "pages/_shared/customer" */).then(function (m) {
		return m.default || m;
	});
};
var _e001cef8 = function _e001cef8() {
	return import('../pages/_shared/partner.vue' /* webpackChunkName: "pages/_shared/partner" */).then(function (m) {
		return m.default || m;
	});
};

var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
	// SavedPosition is only available for popstate navigations.
	if (savedPosition) {
		return savedPosition;
	} else {
		var position = {};
		// If no children detected
		if (to.matched.length < 2) {
			// Scroll to the top of the page
			position = { x: 0, y: 0 };
		} else if (to.matched.some(function (r) {
			return r.components.default.options.scrollToTop;
		})) {
			// If one of the children has scrollToTop option set to true
			position = { x: 0, y: 0 };
		}
		// If link has anchor, scroll to anchor by returning the selector
		if (to.hash) {
			position = { selector: to.hash };
		}
		return position;
	}
};

export function createRouter() {
	return new Router({
		mode: 'history',
		base: '/',
		linkActiveClass: 'nuxt-link-active',
		linkExactActiveClass: 'nuxt-link-exact-active',
		scrollBehavior: scrollBehavior,
		routes: [{
			path: "/",
			component: _4aa1634e,
			name: "index"
		}, {
			path: "/read",
			component: _540aa2bc,
			name: "read"
		}, {
			path: "/partner",
			component: _e28d925c,
			name: "partner"
		}, {
			path: "/engineer",
			component: _745e37bb,
			name: "engineer"
		}, {
			path: "/demo",
			component: _3e0116af,
			name: "demo"
		}, {
			path: "/project",
			component: _60f7b3e3,
			name: "project"
		}, {
			path: "/partner/tasks",
			component: _e6a820de,
			name: "partner-tasks"
		}, {
			path: "/account/requestation",
			component: _61f1b931,
			name: "account-requestation"
		}, {
			path: "/engineer/dashboard",
			component: _12939006,
			name: "engineer-dashboard"
		}, {
			path: "/customer/edit",
			component: _799698bc,
			name: "customer-edit"
		}, {
			path: "/customer/profile",
			component: _03c6d07e,
			name: "customer-profile"
		}, {
			path: "/admin/select-cutomer",
			component: _1030ec05,
			name: "admin-select-cutomer"
		}, {
			path: "/admin/remind",
			component: _7f05dd11,
			name: "admin-remind"
		}, {
			path: "/admin/engineer",
			component: _4b93948a,
			name: "admin-engineer"
		}, {
			path: "/admin/project",
			component: _34fa7760,
			name: "admin-project"
		}, {
			path: "/project/create",
			component: _3499d98a,
			name: "project-create"
		}, {
			path: "/account/change-password",
			component: _6ee0f1fd,
			name: "account-change-password"
		}, {
			path: "/partner/edit",
			component: _1c106b8c,
			name: "partner-edit"
		}, {
			path: "/account/registration",
			component: _792c66a4,
			name: "account-registration"
		}, {
			path: "/admin/task",
			component: _ca499464,
			name: "admin-task"
		}, {
			path: "/admin/dashboard",
			component: _41e0119b,
			name: "admin-dashboard"
		}, {
			path: "/engineer/project",
			component: _e6ea637c,
			name: "engineer-project"
		}, {
			path: "/partner/profile",
			component: _59414428,
			name: "partner-profile"
		}, {
			path: "/account/redirect",
			component: _13e20dc7,
			name: "account-redirect"
		}, {
			path: "/admin/setting",
			component: _65b6c717,
			name: "admin-setting"
		}, {
			path: "/customer/dashboard",
			component: _3da28b2c,
			name: "customer-dashboard"
		}, {
			path: "/account/profile",
			component: _5beb980e,
			name: "account-profile"
		}, {
			path: "/account/upload",
			component: _59ec7ba8,
			name: "account-upload"
		}, {
			path: "/admin/partner",
			component: _2ee978d2,
			name: "admin-partner"
		}, {
			path: "/admin/customer-list",
			component: _2b93f034,
			name: "admin-customer-list"
		}, {
			path: "/partner/dashboard",
			component: _5ebdd394,
			name: "partner-dashboard"
		}, {
			path: "/engineer/settings",
			component: _216f7b6c,
			name: "engineer-settings"
		}, {
			path: "/admin/user",
			component: _678dc097,
			name: "admin-user"
		}, {
			path: "/project/create-demo",
			component: _664b1765,
			name: "project-create-demo"
		}, {
			path: "/engineer/edit",
			component: _22aa8831,
			name: "engineer-edit"
		}, {
			path: "/account/forgot-password",
			component: _7302156a,
			name: "account-forgot-password"
		}, {
			path: "/admin/edit",
			component: _12caa3d3,
			name: "admin-edit"
		}, {
			path: "/customer/list-project",
			component: _956592fc,
			name: "customer-list-project"
		}, {
			path: "/customer/setting",
			component: _27871e30,
			name: "customer-setting"
		}, {
			path: "/account/request-password",
			component: _4e332ef8,
			name: "account-request-password"
		}, {
			path: "/admin/customer",
			component: _4af1786a,
			name: "admin-customer"
		}, {
			path: "/admin/customer/create-project",
			component: _08704be0,
			name: "admin-customer-create-project"
		}, {
			path: "/admin/user/create",
			component: _9c42c5f2,
			name: "admin-user-create"
		}, {
			path: "/admin/partner/resend",
			component: _166c1feb,
			name: "admin-partner-resend"
		}, {
			path: "/project/quotation/create-revise",
			component: _7555d877,
			name: "project-quotation-create-revise"
		}, {
			path: "/project/quotation/create",
			component: _6c15fade,
			name: "project-quotation-create"
		}, {
			path: "/admin/email/setting",
			component: _236045e4,
			name: "admin-email-setting"
		}, {
			path: "/admin/customer/create",
			component: _3af1df94,
			name: "admin-customer-create"
		}, {
			path: "/admin/engineer/create",
			component: _d776673a,
			name: "admin-engineer-create"
		}, {
			path: "/admin/user/role",
			component: _5e75fbf8,
			name: "admin-user-role"
		}, {
			path: "/admin/partner/create",
			component: _540c27a8,
			name: "admin-partner-create"
		}, {
			path: "/admin/email/resend",
			component: _490becd7,
			name: "admin-email-resend"
		}, {
			path: "/project/tasks/edit/:id?",
			component: _1747a856,
			name: "project-tasks-edit-id"
		}, {
			path: "/admin/customer/edit/:id?",
			component: _298da24d,
			name: "admin-customer-edit-id"
		}, {
			path: "/admin/user/edit/:id?",
			component: _cf7e6200,
			name: "admin-user-edit-id"
		}, {
			path: "/admin/engineer/edit/:id?",
			component: _79d8975c,
			name: "admin-engineer-edit-id"
		}, {
			path: "/admin/partner/edit/:id?",
			component: _22c4e8e5,
			name: "admin-partner-edit-id"
		}, {
			path: "/project/tasks/view/:id?",
			component: _4b472d70,
			name: "project-tasks-view-id"
		}, {
			path: "/partner/tasks/:id",
			component: _ea3abb8e,
			name: "partner-tasks-id"
		}, {
			path: "/admin/customer/:id",
			component: _4312e55c,
			name: "admin-customer-id"
		}, {
			path: "/customer/project/:id?",
			component: _61fa6e5c,
			name: "customer-project-id"
		}, {
			path: "/admin/engineer/:id",
			component: _b0872a3a,
			name: "admin-engineer-id"
		}, {
			path: "/admin/partner/:id",
			component: _61c387ba,
			name: "admin-partner-id"
		}, {
			path: "/project/quotation/:id?",
			component: _c9317370,
			name: "project-quotation-id"
		}, {
			path: "/project/edit/:id?",
			component: _28d08834,
			name: "project-edit-id"
		}, {
			path: "/admin/user/:id",
			component: _6ff0fcbf,
			name: "admin-user-id"
		}, {
			path: "/project/tasks/:id?",
			component: _1eeba26c,
			name: "project-tasks-id"
		}, {
			path: "/partner/tasks/t:id_backup",
			component: _1c3dc74c,
			name: "partner-tasks-tid_backup"
		}, {
			path: "/engineer/:id",
			component: _4ffcece3,
			name: "engineer-id"
		}, {
			path: "/resend/:id?",
			component: _ca2bf222,
			name: "resend-id"
		}, {
			path: "/partner/:id",
			component: _4e6ac5ba,
			name: "partner-id"
		}, {
			path: "/customer/:id?",
			component: _f291e15c,
			name: "customer-id"
		}, {
			path: "/account/:login?",
			component: _224daa15,
			name: "account-login"
		}, {
			path: "/project/:id",
			component: _3997530b,
			name: "project-id"
		}, {
			path: "/:shared/user",
			component: _15b5463f,
			name: "shared-user"
		}, {
			path: "/:shared/engineer",
			component: _8b964e3a,
			name: "shared-engineer"
		}, {
			path: "/:shared/admin",
			component: _deb6c6ea,
			name: "shared-admin"
		}, {
			path: "/:shared/customer",
			component: _c2f0ea5c,
			name: "shared-customer"
		}, {
			path: "/:shared/partner",
			component: _e001cef8,
			name: "shared-partner"
		}],

		fallback: false
	});
}


//////////////////
// WEBPACK FOOTER
// ./.nuxt/router.js
// module id = ./.nuxt/router.js
// module chunks = 82